import React from 'react';
import { Button, useToggleObject } from '@uplift/ui-v2';
import { Add } from '@mui/icons-material';
import { usePsychiatryReferralFlow } from './usePsychiatryReferralFlow.hook';
import { MatchingFlowContainer } from './MatchingFlow.container';
import { useUserWithProfileQuery } from '@uplift/queries';


export type PsychiatryReferralFlowProps = {
  patientId: string;
};


export const PsychiatryReferralFlow: React.FC<PsychiatryReferralFlowProps> = (props) => {
  const { data: { user, profile } } = useUserWithProfileQuery(props.patientId);

  const {
    open: matchingFlowOpen,
    close: matchingFlowClose,
    value: matchingFlowOpened
  } = useToggleObject();
  const {
    stateId,
    isPsychiatryMatchingAllowed,
    psychiatryData,
    matchingFetching,
    matchingFlowContainerAvailable,
    matchingProvidersType,
  } = usePsychiatryReferralFlow({ patientId: props.patientId });

  if (matchingFetching) return null;
  if (!isPsychiatryMatchingAllowed) return null;

  return (
    <>
      <Button
        disabled={!psychiatryData?.length}
        color="secondary"
        startIcon={<Add />}
        onClick={matchingFlowOpen}
      >
        Connect to a new Provider
      </Button>

      {matchingFlowContainerAvailable && (
        <MatchingFlowContainer
          stateId={stateId}
          open={matchingFlowOpened}
          onClose={matchingFlowClose}
          patientName={profile?.preferredName || user?.firstName}
          patientId={props.patientId}
          providers={psychiatryData}
          matchingProvidersType={matchingProvidersType}
        />
      )}
    </>
  );
};
